import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';
import { IconComponent, SafeHtmlPipe } from '@ui';
import { HelpTemplateItem } from './help-center.models';
import { TranslocoDirective } from '@jsverse/transloco';
import { NameComponent } from "./help-center-template-header.component";

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [IconComponent, SafeHtmlPipe, TranslocoDirective, NameComponent],
  selector: 'app-help-template',
  template: `
    <ng-container *transloco="let t">
      <app-template-header (sendClose)="emitClosePopover()" />
      <div
        class="mt-[-37px] mx-2 bg-white p-1.5 rounded-md shadow overflow-auto max-h-[calc(100vh-300px)]"
      >
        <ul class="list-none p-0 grid grid-cols-1 gap-2">
          @for (item of items(); track item.url) {
            <li class="flex items-center justify-center shadow-sm rounded-md border border-gray-100">
              <a
                href="{{ item.url }}"
                target="_blank"
                class="flex flex-col items-center justify-center h-[108px] w-[115px] text-center text-gray-700 text-sm"
              >
                <ui-icon class="mb-2 text-primary" [icon]="item.icon" [class]="'text-xl'"></ui-icon>
                <span [innerHTML]="t(item.label) | safeHtml"></span>
              </a>
            </li>
          }
        </ul>
      </div>
    </ng-container>
  `,
})
export class HelpTemplateComponent {
  sendClose = output<void>();
  items = input<HelpTemplateItem[]>();

  emitClosePopover(): void {
    this.sendClose.emit();
  }
}
